
/**
 * 公用参数
 */
let publicParams = {

    game: '',

    searchUrl: sessionStorage.tokenParams||sessionStorage.dataSearch||location.search,
    
    searchObj: {
        acctype: undefined,
        openid: undefined,
        partition: undefined,
        roleid: undefined
    },

    mosso_to_dmp: true
}

export { publicParams }